










import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ChatMessage extends Vue {
    @Prop() time?: string;
    @Prop({default:false}) sentByMe?: boolean;
    @Prop() image?: string;
    @Prop() imageAlt?: string;
    @Prop() imageIntro?: string;
}
